<template>
    <div v-if="! is_picked">
        <b-card class="mb-6 card-style">
            <b-card-text>
                <div v-if="! pkey">
                    <div :key="category" v-for="(subitems, category) in items" class="section-block">
                        <strong class="label">{{ category }}</strong>

                        <div class="choices">
                            <button :key="item.id" v-for="item in subitems" @click="onSelectPart(item, category)" class="btn btn-light">{{ item.title }}</button>
                        </div>
                    </div>
                </div>

                <div v-else>
                    <div class="choices">
                        <button :key="item.id" v-for="item in items" @click="onSelectPart(item)" class="btn btn-light">{{ item.title }}</button>
                    </div>
                </div>

            </b-card-text>
        </b-card>
    </div>

    <div v-else>
        <b-card class="mb-6 card-style">
            <b-card-text :class="{ 'with-category': this.selected.category }">
                <div v-if="this.selected.category">
                    <strong>{{ this.selected.category }}</strong>
                </div>

                {{ this.selected.title }}
                <b-button href="#" variant="info" @click="onChangePart">Change</b-button>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
    export default {
        props: ['pkey', 'items'],
        data () {
            return {
                selected: false,
                is_picked: false
            }
        },

        methods: {
            onSelectPart (item) {
                let hasChanged = false

                if (this.selected) {
                    // check if nothing has changed, and user picked the same item again
                    if (this.selected.id == item.id) {
                        this.is_picked = true
                        return
                    }

                    hasChanged = true
                }

                // --------------------------------------------------------------

                this.selected = item
                this.is_picked = true

                this.$emit(
                    'picked', {
                        key: this.pkey,
                        selected: item
                    },
                    hasChanged ? 'changed' : 'created'
                )
            },

            onChangePart () {
                this.is_picked = false
            }
        }
    }
</script>

<style scoped>
    .choices {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-gap:15px;
    }

    /*.choices button {
        display: inline-block;
        padding: 4px 12px;
        margin-bottom: 0;
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        text-align: center;
        text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);
        vertical-align: middle;
        cursor: pointer;
        background-color: #f5f5f5;
        background-image: -moz-linear-gradient(top, #ffffff, #e6e6e6);
        background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#ffffff), to(#e6e6e6));
        background-image: -webkit-linear-gradient(top, #ffffff, #e6e6e6);
        background-image: -o-linear-gradient(top, #ffffff, #e6e6e6);
        background-image: linear-gradient(to bottom, #ffffff, #e6e6e6);
        background-repeat: repeat-x;
        border: 1px solid #cccccc;
        border-color: #e6e6e6 #e6e6e6 #bfbfbf;
        border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
        border-bottom-color: #b3b3b3;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#ffe6e6e6', GradientType=0);
        filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
        -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
        -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);        
    }
    .choices button:hover {
      background: #e6e6e6;
    }
    .choices button:focus {
        background: #e6e6e6;
        background-image: none;
        outline: 0;
        -webkit-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);
        -moz-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);
    }*/
    .btn-light {
        background-color: #fff;
        border-color: #fff;
        -moz-box-shadow: inset 0 0 10px rgba(0,0,0,0.1);
        -webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.1);
        box-shadow: inset 0 0 10px rgba(0,0,0,0.1);
    }
    .btn-light:hover, .btn-light:focus {
        background-color:#E2E6EA;
        border-color:#E2E6EA;
    }
    .card-style {
        background-color: #0D3C65;
        border: 1px solid #0D3C65;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.05);
        -moz-box-shadow: inset 0 1px 1px rgba(0,0,0,0.05);
        box-shadow: inset 0 1px 1px rgba(0,0,0,0.05);
        position:relative;
        margin-top:20px;
        color:#fff;
    }

    .card-style p {
        margin:0px;
    }

    .card-style .btn-info {
        position: absolute;
        right: 15px;
        top: 13px;
    }

    .with-category .btn-info {
        top:25px;
    }

    .label {
        display:block;
        text-align:left;
        margin:20px 0;
        color:#fff;
    }

    .card-text {
        text-align:left;
    }

    .section-block:first-child .label {
        margin-top:0px;
    }
</style>
